/*eslint array-callback-return: "off"*/
import React, { useContext } from "react";
import palette from "../../theme/palette";
import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core";
import shape from "../../theme/shape";
import { UserTypeContext } from "../../context/userStatus";
import ModalCloseIconBlack from "../../assets/images/icon/modalCloseIconBlack";

const useStyles = makeStyles((theme) => ({
  drawerWrapper: {
    padding: "0",
    height: "100%",
  },
  ideasList: {
    marginTop: "40px",
    [theme.breakpoints.down("lg")]: {
      marginTop: "30px",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "20px",
    },
  },
  ideasListItem: {
    backgroundColor: palette.common.white,
    borderRadius: "12px",
    padding: "16px",
    fontSize: "1rem",
    lineHeight: "100%",
    gap: "8px",
    color: palette.common.black,
    fontWeight: 400,
    marginBottom: "12px",
    cursor: "pointer",
    border: "1px solid #EFEFEF",
    [theme.breakpoints.down("md")]: {
      padding: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
    },
  },
}));

interface RightSideOutcomeTrackingModal {
  outcomeIdeas: any;
  outcomeData?: any
  setOutcomeValue: (outComeValue: any) => void;
  setOpenRightSideSuggestion: (visible: boolean) => void;
}

const RightSideOutcomeTrackingNew = (props: RightSideOutcomeTrackingModal) => {
  const classes = useStyles();
  const { state: outcomeState } = useContext(UserTypeContext);

  return (
    <Grid
      // sx={{ backgroundColor: palette.primary.main }}
      className={classes.drawerWrapper}
    >
      <Grid display={"flex"} alignItems={"flex-start"} justifyContent={"space-between"} gap={4}>
        <Typography
          variant="h3"
          component="h3"
          sx={{
            color: palette.common.black,
            fontWeight: 600,
            fontSize: "1.125rem !important",
            lineHeight: "120%!important",
          }}
        >
          Here are some ideas of outcomes you might want to consider
        </Typography>
        <span
          onClick={() => props.setOpenRightSideSuggestion(false)}
          style={{
            cursor: "pointer"
          }}
        >
          <ModalCloseIconBlack />
        </span>
      </Grid>
      <Grid className={classes.ideasList} sx={{ width: "100%" }}>
        {props?.outcomeIdeas?.map((ideas: any) => {
          let flag = true;
          if (outcomeState?.outcomeList?.length > 0)
            for (let outObj of outcomeState?.outcomeList) {
              if (outObj.name.toLowerCase() === ideas.name.toLowerCase()) {
                flag = false;
                break;
              }
            }
          if (flag) {
            return (
              <div
                className={classes.ideasListItem}
                key={ideas._id}
                onClick={() => props.setOutcomeValue(ideas)}
              >
                {ideas.name}
              </div>
            );
          }
        })}
        {props?.outcomeData && props?.outcomeData?.map((ideas: any) => {
          let flag = true;
          if (outcomeState?.outcomeList?.length > 0)
            for (let outObj of outcomeState?.outcomeList) {
              if (outObj.name.toLowerCase() === ideas.name.toLowerCase()) {
                flag = false;
                break;
              }
            }
          if (flag) {
            return (
              <div
                className={classes.ideasListItem}
                key={ideas._id}
                onClick={() => props.setOutcomeValue(ideas)}
              >
                {ideas.name}
              </div>
            );
          }
        })}
      </Grid>
    </Grid>
  );
};
export default RightSideOutcomeTrackingNew;
